module.exports = __webpack_public_path__ + "static/media/larry1.e90be80e.mp3";